import {Icon, Text} from "@reside/ui";
import {WarningContainer} from "./styles";
import {useAutoLogoutInfo} from "../../contexts/AutoLogoutInfoContext";

/**
 * Displays "Your session has expired" message on login pages
 * Used on both Admin (/admin/login) and RE (/admission/welcome) login pages
 * Shows when auto-logout occurs; Doesn't show on manual logout; Hides when user logs back in;
 */
export const AutoLogoutInfoBar = (): JSX.Element | null => {
  const {isAutoLoggedOut} = useAutoLogoutInfo();

  if (isAutoLoggedOut) {
    return (
      <WarningContainer>
        <Icon name="info" />
        <Text>Your session has expired for security reasons.</Text>
      </WarningContainer>
    );
  }
  return null;
};
